import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';

/**
 * Cheat-sheet-sectiekop van de cyclus-keynotes (Persoonlijk / Educatief /
 * Omgevend / Vernieuwing): gekleurde kaartbalk met wit icoon, titel + de
 * "transit brengt …"-regel en de chevron helemaal rechts. De kop is een knop:
 * de ouder klapt er zijn bullets mee uit of in ({@link toggle}).
 *
 * Gedeeld door het Geavanceerd-paneel van cycle-/momentcharts
 * (`hd-cycle-keynote-sections`) en het Just Now-paneel; dat laatste zet de kop
 * `sticky` zodat de context (Persoonlijk, Educatief, …) zichtbaar blijft terwijl
 * de I Tjing-kaarten eronder scrollen.
 */
@Component({
  selector: 'hd-cycle-section-header',
  templateUrl: './hd-cycle-section-header.component.html',
  styleUrl: './hd-cycle-section-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-sticky]': 'sticky()',
  },
})
export class HdCycleSectionHeaderComponent {
  /** Cheat-sheet-kaartkleur van de keynote (achtergrond van de balk). */
  readonly color = input.required<string>();
  /** Bare FA-icoonnaam; leeg = geen icoon. */
  readonly faIcon = input('');
  readonly title = input.required<string>();
  /** Label vóór de brings-tekst ("transit brengt:"). */
  readonly bringsLabel = input('');
  /** HTML met `<b>`-accenten (uit de cycles-scope, via `[innerHTML]`); leeg = geen tweede regel. */
  readonly brings = input('');
  /** Of de bullets van de ouder uitgeklapt staan (aria + chevron). */
  readonly expanded = input(false);
  /** Blijft bovenaan de scrollcontainer kleven. */
  readonly sticky = input(false, { transform: booleanAttribute });

  readonly toggle = output<void>();
}
